/** Положение галочки относительно текста соглашения в форме (FormCheckMarkPositionModel на бэкенде) */
export enum FormCheckMarkPosition {
    Right = 0,
    Left = 1,
}

export const DEFAULT_CHECK_MARK_POSITION = FormCheckMarkPosition.Left;
export const DEFAULT_CHECK_MARK_STATE = false;
/** Положение галочки относительно текста соглашения в форме (FormCheckMarkPositionModel на бэкенде) */
export enum FormCheckMarkPosition {
    Right = 0,
    Left = 1,
}

export const DEFAULT_CHECK_MARK_POSITION = FormCheckMarkPosition.Left;
export const DEFAULT_CHECK_MARK_STATE = false;
